import { render } from "./DateTabletFormComponent.vue?vue&type=template&id=63ef9092"
import script from "./DateTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./DateTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__